module.exports = __webpack_public_path__ + "img/2_david_n.6751a113.png";